import {
  Component,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import {
  Translate
} from '../../services';

@Component({
  selector: 'cs-section-result',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="cs-final-report-page__report">
      <h1 [style.color]="inputs.color">
        {{ inputs.label }}
      </h1>
      <ul>
        <li>
          <span class="cs-label">{{ (translations$ | async)['global#total_questions'] }}</span> 
          <span class="cs-value">{{ inputs.totalQuestions }}</span>
        </li>
        <li class="cs-final-report-page__item-exact">
          <span class="cs-label">{{ (translations$ | async)['global#right_answers'] }}</span> 
          <span 
            class="cs-value">
            {{ inputs.rightAnswers }}
          </span>
        </li>
        <li>
          <span class="cs-label">{{ (translations$ | async)['global#wrong_answers'] }}</span> 
          <span class="cs-value">{{ inputs.wrongAnswers }}</span>
        </li>
        <li class="cs-final-report-page__item-invalid">
          <span class="cs-label">{{ (translations$ | async)['global#null_answers'] }}</span> 
          <span class="cs-value">{{ inputs.nullAnswers }}</span></li>
        <li class="cs-final-report-page__item-sum">
          <span class="cs-label">{{ (translations$ | async)['global#section_points'] }}</span> 
          <span class="cs-value">{{ inputs.sectionPoints }}</span>
        </li>
      </ul>
    </section>
  `
})

export class CsSectionResultComponent {
  @Input() inputs: any = {};
  translations$: Observable<any> = this.translate.getTranslations$();

  constructor(
    private translate: Translate
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-section-result/cs-section-result.component.ts